import { Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Services from "./Pages/Services";
import Gallery from "./Pages/Gallery";
import Contact from "./Pages/Contact";
import Terms from "./Pages/Terms";
import Privacy from "./Pages/Privacy";
import Fixed from "./Components/Fixed";
import NotFound from "./Pages/NotFound";

function App() {
  return (
    <>
<Fixed/>
      <Routes>
    
        <Route path="/" element={<Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/Gallery" element={<Gallery />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Terms" element={<Terms />} />
        <Route path="/Privacy" element={<Privacy />} />
        <Route path="/NotFound" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
